module.exports = __webpack_public_path__ + "static/media/startup_ole.9aaf9b80.png";